export { default as NewsCardMain } from './NewsCardMain'
export { default as NewsCardMainSkeleton } from './Skeleton'
